import {$, w} from './constants';

//Planes

(function( $ ){

    let final_price = 0;
    let plan_price = 0;
    let add_ons_total = 0;
    let services_total = 0;

    let add_ons_list = {};
    let services_list = {};

    let add_extra = '';

    $('.btn-qty').click( function () {
        let new_val = 0;
        let new_total = 0;

        let $button = $(this);
        let old_value = parseFloat( $button.siblings('.input-class--value').val() );
        let current_max = $button.parent().data('max');

        let current_price = $( this ).parent().parent().siblings( '.calculator__checkbox' ).find( '.add-on-price' ).text();
        let current_add_on = $( this ).parent().parent().siblings( '.calculator__checkbox' ).find( '.add-on-name' ).text();
        let $total_current = $( this ).parent().parent().siblings( '.calculator__total' ).find( '.total-add-on' );
        let check_box = $( this ).parent().parent().siblings( '.calculator__checkbox' ).find( '.add-on-cb' ).get(0);
        
        let total_current_value = $total_current.data( 'price' );

        if( !check_box.checked ){
            if ( $button.hasClass( 'button--qty-minus' ) ) {
                return;
            }

            $( check_box ).prop("checked", true);
            activeCheckbox( check_box );
        }

        if ( $button.hasClass( 'button--qty-plus' ) ) {

            //Checamos si el check de de este elemento está activado
            if( current_max <= old_value ){
                return false;
            }

            new_val = parseFloat( old_value ) + 1;
            new_total = parseFloat( total_current_value ) + parseFloat( current_price );

        } else {

            //No se permiten valores menores a cero
            if ( old_value > 0 ) {

                new_total = parseFloat( total_current_value ) - parseFloat( current_price );
                new_val = parseFloat( old_value ) - 1;

            } else {

                new_total = 0;
                new_val = 0;

            }
        }

        //Agregamos al listado los productos y su cantidad
        add_ons_list[current_add_on] = new_val;

        //Pintamos las cantidades
        $button.siblings( '.input-class--value' ).val( new_val );
        if( new_total == 0 ){

            $total_current.text( 0 );
            $total_current.data( 'price', 0 );
            $( check_box ).prop("checked", false);

            inactiveCheckbox( check_box );
        }else{
            $total_current.data( 'price', new_total );
            $total_current.text( new_total.format(2) );
        }

        updateAddOnsFinalPrice();
        updateFinalStats();
    });

    $('.input-class--value').focusout(function(){
        let current_max = $(this).parent().data('max');
        let current_add_on = $( this ).parent().parent().siblings( '.calculator__checkbox' ).find( '.add-on-name' ).text();
        let $total_current = $( this ).parent().parent().siblings( '.calculator__total' ).find( '.total-add-on' );
        let current_price = $( this ).parent().parent().siblings( '.calculator__checkbox' ).find( '.add-on-price' ).text();
        let current_message = $( this ).parent().parent().parent();
        let new_total = 0;

        add_ons_list[ current_add_on ] = 0;
        $total_current.text( 0 );
        
        if( $( this ).val() > 0 && $( this ).val() <= current_max ){

            new_total =  parseFloat( current_price ) * $( this ).val();
            add_ons_list[ current_add_on ] = $( this ).val();

        }else{

            new_total =  parseFloat( current_price ) * current_max;
            $( this ).val( current_max );
            add_ons_list[ current_add_on ] = current_max;

            showMessage( $( current_message ).data('id'), $( current_message ).data('message') );
        }

        $total_current.text( new_total.format(2) );
        $total_current.data( 'price', new_total );

        updateAddOnsFinalPrice();
        updateFinalStats();

        return false;

    });

    function openPopup(){
        $('#message-calculator').fadeIn(300).addClass('show');
    }

    $( '#show-plan-pro' ).click(function(){
        $( '#message-calculator' ).removeClass( 'show' );
        $( '#calculadora' ).removeClass( 'show' );

        $( '.btn-plan' ).each( function( pos, element ) {
            if ( $(element).attr('id').indexOf('pro')  >= 0  ){
                $(element).trigger('click');
                scrollCalculator();
                return;
            }
        });
    });

    $('.pop-up-calculator__close').click(function(){
        $('#message-calculator').removeClass('show');
    })

    const scrollCalculator = (e) =>{
        $('.calculator__scroll').animate({
            scrollTop: $("#anchor-step-1").position().top
        }, 200);
    }

    function showMessage( id, message ){

        $( '#' + id ).removeClass( 'hide' );
        $( '#' + id ).text( message );

        setTimeout(function(){ 
            $( '#' + id ).addClass( 'hide' );
        }, 4000);
    }

    function updateAddOnsFinalPrice(){
        add_ons_total = 0;

        $('.total-add-on').each( function( pos, element ) {
            add_ons_total += parseFloat( $(element).data( 'price' ) );
        });

        $('#precio-final-add-ons').data( 'price', add_ons_total );
        $('#precio-final-add-ons').text( add_ons_total.format(2) );
    }

    $('.services').click( function () {

        let current_service = $( this ).parent().find( '.service-name' ).text().trim();
        let current_price = $( this ).parent().find( '.service-price' ).text().trim();
        let $total_current = $( this ).parent().parent().siblings( '.calculator__total' ).find( '.service-total' );

        if( $(this).prop('checked') ){
            services_list[current_service] = 1;
            $total_current.text( current_price );
        }else{
            services_list[current_service] = 0;
            $total_current.text( 0 );
        }

        updateServicesFinalPrice();
        updateFinalStats();
    });

    function updateServicesFinalPrice(){
        services_total = 0;

        $('.service-total').each( function( pos, element ) {
            services_total += parseFloat( $(element).text() );
        });

        $('#final-price-services').text( services_total.format(2) );
    }

    $('.btn-plan').click(function(){
        resetElements();
        
        plan_price = $( this ).data( 'price' );
        //let format_price = new Intl.NumberFormat('en-US').format(plan_price);
        let plan_name = $( this ).data( 'name' ).toLowerCase();

        $(' #plan-price-selected, #final-price ').text( plan_price.format() );
        $(' #plan-name-selected, #plan-name-final ').text( $( this ).data( 'name' ) );
        $(' #plan-type-selected, #final-type ').text( $( this ).data( 'type' ) );

        $('#add-ons-list').html('');

        $('#calculadora').fadeIn(500).addClass('show');

    })

    function updateFinalStats(){
        let html_add_ons = '';
        let html_services = '';
        let clean_list_add_ons = {};
        let clean_list_services = {};

        //Limpuamos los que son cero
        $.each( add_ons_list, function( key, value ) {
            if( value > 0 ){
                clean_list_add_ons[ key ] = value;
            }
        });

        $.each( services_list, function( key, value ) {
            if( value > 0 ){
                clean_list_services[ key ] = value;
            }
        });

        $.each( clean_list_add_ons, function( key, value ) {
            //Agregamos las comas y las quitamos si es el último elemento
            html_add_ons += '<span><strong>' + value + '</strong> ' + key.trim() + '</span>';
        });

        $.each( clean_list_services, function( key, value ) {
            html_services += '<span><strong>' + value + '</strong> ' + key.trim() + '</span>';
        });

        final_price = parseFloat( plan_price ) + parseFloat( add_ons_total ) + parseFloat( services_total );

        $('#add-ons-list').html( html_add_ons );
        $('#services-list').html( html_services );
        $('#final-price').text( final_price.format(2) );

        if( add_extra.length ){
            $('#add-ons-list').append( add_extra );
        }
    }

    function resetElements(){
        let final_price = 0;
        let plan_price = 0;
        let add_ons_total = 0;
        let services_total = 0;

        let add_ons_list = {};
        let services_list = {};

        let add_extra = '';

        $('.input-class--value').each(function(index, el) {
            $(el).val(0);  
        });

        $('.check').each(function(index, el) {
            $(el).prop({checked: false});  
            $(el).parent().removeClass( 'active' );
        });

        $('.total-add-on').each( function( pos, element ) {
            $(element).text( '0' );
            $(element).data( 'price', '0' );
        });

        $('#precio-final-add-ons').text( '0' );

        $('.service-total').each( function( pos, element ) {
            $(element).text( '0' );
            $(element).data( 'price', '0' );
        });

        $('#final-price-services').text( '0' );

        $('#add-ons-list').html( '' );
        $('#services-list').html( '' );
        $('#final-price').text( plan_price.toFixed(2) );

    }

    $('input[type=checkbox]').change(function(){
        let input = $( this ).parent().parent().siblings( '.calculator__input' ).find('.input-class--value');
        let current_total = $( this ).parent().parent().siblings( '.calculator__total' ).find('.total-add-on');
        let current_add_on = $( this ).siblings('p').find('.add-on-name').text();

        if($(this).prop('checked')){

            activeCheckbox( this );
            addFirstElement( this, input, current_add_on, current_total );
        }else{
            inactiveCheckbox( this, input, current_add_on, current_total );
        }

        updateAddOnsFinalPrice();
        updateFinalStats();
    });

    function addFirstElement( element, input, current_add_on, current_total ){
        let current_price = $( element ).parent().find( '.add-on-price' ).text();

        $( input ).val( 1 );
        $( current_total ).text( parseFloat( current_price ).format(2) );
        $( current_total ).data( 'price', current_price );
        add_ons_list[ current_add_on ] = 1;

    }

    function inactiveCheckbox( element, input, current_add_on, current_total ){
        //Si es add on
        if( $( element ).hasClass( 'add-on-cb' ) ){
                let add_ons_label = $('#precio-final-add-ons');
                let discount = parseFloat( add_ons_label.data('price') ) - parseFloat( $( current_total ).text() );

                $(input).val( 0 );

                add_ons_list[ current_add_on ] = 0;

                if( discount == 0 ){
                    add_ons_label.text( discount.format() );
                }else{
                    add_ons_label.text( discount.format(2) );
                }

                add_ons_label.data( 'price' , discount );
                $( current_total ).text( '0' );
        }

        $( element ).parent().removeClass('active');
        $( element ).parent().parent().siblings('.calculator__input').find('.input-class--value').prop({disabled: true});
        
        if($(window).width() < 901){
            $( element ).parent().parent().siblings('.calculator__input').removeClass('show');
            $( element ).parent().parent().siblings('.calculator__total').removeClass('show');
        }
    }

    function activeCheckbox( element ){
        $(element).parent().addClass('active');
        $(element).parent().parent().siblings('.calculator__input').find('.input-class--value').prop({disabled: false});

        if($(window).width() < 901){
            console.log('Mobile')
            $(element).parent().parent().siblings('.calculator__input').addClass('show');
            $(element).parent().parent().siblings('.calculator__total').addClass('show');
        }
    }

    Number.prototype.format = function(n, x) {
        var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\.' : '$') + ')';
        return this.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$&,');
    };

})( jQuery );

$('.calculator__close').click(function(){
    $(this).parent().fadeOut(500).removeClass('show');
    $('.step-container-1').removeClass('hide');
    $('.plans-select__title--pop').removeClass('hide');
    $('.calculator__header--start').removeClass('hide');
    $('.step-container-2').addClass('hide');
    $('.step-container-3').addClass('hide');
    $('.step-container-4').addClass('hide');
})

$('.step-1').click(function(e){
    e.preventDefault();
    $('.step-container-2').addClass('hide');
    $('.step-container-1').removeClass('hide');
    $('#calculadora').animate({
        scrollTop: $('#anchor-step-1').offset().top - 400
    }, 200);
    $('.calculator__header').removeClass('hide');
   
})

$('.step-2').click(function(e){
    e.preventDefault();
    $('.step-container-1').addClass('hide');
    $('.calculator__header--start').addClass('hide');
    $('.plans-select__title--pop').addClass('hide');
    $('#calculadora').animate({
        scrollTop: $('#step-3').offset().top - 60
    }, 200);
    $('.step-container-3').removeClass('hide');
    
})

$('.step-3').click(function(e){
    e.preventDefault();
    $('.step-container-2').addClass('hide');
    $('.plans-select__title--pop').addClass('hide');
    $('#calculadora').animate({
        scrollTop: $('#step-3').offset().top - 60
    }, 200);
    $('.step-container-3').removeClass('hide');
})

$('.step-return').click(function(e){
    e.preventDefault();
    $('.step-container-3').addClass('hide');
    $('.calculator__header--start').removeClass('hide');
    $('.plans-select__title--pop').removeClass('hide');
    $('#calculadora').animate({
        scrollTop: "0px"
    }, 200);
    $('.step-container-1').removeClass('hide');
})

$('.close-and-form').click(function(e){
    e.preventDefault();
    $('.step-container-3').addClass('hide');
    $('.step-container-2').addClass('hide');
    $('.step-container-4').removeClass('hide');
})

let flagDiv = true;
$('.plans-select__table-info').click(function(){
    $(this).toggleClass('show');
    $(this).children('.button--plusx12').toggleClass('show');
    $(this).siblings('.plans-select__table-dropdown').toggleClass('show');
    let dad = $(this).parent().offset().top
    flagDiv = !flagDiv;
    (flagDiv) ? $('html, body').animate({
        scrollTop: dad - 70
    }, 500) : '';
});
